import { Avatar, Badge, Box, ListItemAvatar, useTheme } from "@mui/material";
import { avatarColor, avatarSrc, getInitials } from "../../utils/avatar";

const UserAvatar = ({ selectedUser }) => {
  const theme = useTheme()

  return (
    <>
      <ListItemAvatar>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: selectedUser.isOnline ? '#35C759' : '#9E9E9E',
                border: `1px solid ${ theme.palette.background.paper }`,
                boxSizing: 'content-box',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.35)',
              }}
            />
          }
        >
          <Avatar
            src={avatarSrc(selectedUser.avatar)}
            sx={{
              width: 42,
              height: 42,
              ...avatarColor(selectedUser.name, theme.palette.mode),
              border: `2px solid ${theme.palette.neutral.main}`
            }}
          >
            {getInitials(selectedUser.name)}
          </Avatar>
        </Badge>
      </ListItemAvatar>
    </>
  );
};

export default UserAvatar;